import { defineStore } from 'pinia';
import api from '../../api';

export const usePoeStore = defineStore('poe', {
  state: () => ({
    deviceInfo: {}, // 设备信息
    deviceTime: '', // 设备当前时间
    poeScheduleList: [],
    poeScheduleListUpdated: false,
    poePortConfig: [],
    poeInfo: []
  }),

  actions: {
    queryPOEInfo(params) {
      return api.poe.queryPOEInfo(params)
        .then(data => {
          if (data.resp.respCode === 0) {
            this.setPoePortConfig(data.poePortConfig)
          }
          return data;
        })
        .catch(error => { throw error; });
    },
    setPoePortConfig(data){
      this.poePortConfig = data;
    },
    setPOE(params) {
      return api.poe.setPOE(params)
        .then(data => data)
        .catch(error => { throw error; });
    },
    queryScheduleList(params) {
      return api.poe.queryScheduleList(params)
        .then(data => {
          if (data.resp.respCode === 0) {
            this.setPoeScheduleList(data.poeSchedule)
          }
          return data;
        })
        .catch(error => { throw error; });
    },
    setPoeScheduleList(data){
      this.poeScheduleList = data;
      this.poeScheduleListUpdated = true;
    },
    updateSchedule(params) {
      return api.poe.updateSchedule(params)
        .then(data => data)
        .catch(error => { throw error; });
    },
    setSchedule(params) {
      return api.poe.setSchedule(params)
        .then(data => data)
        .catch(error => { throw error; });
    },
    deleteSchedule(params) {
      return api.poe.deleteSchedule(params)
        .then(data => data)
        .catch(error => { throw error; });
    },
    queryGlobalPoeInfo(params) {
      return api.poe.queryGlobalPoeInfo(params)
        .then(data => {
          if (data.resp.respCode === 0) {
            this.setPoeInfo(data.poeInfo)
          }
          return data;
        })
        .catch(error => { throw error; });
    },
    setPoeInfo(data){
      this.poeInfo = data;
    },
    associationPoe(params) {
      return api.poe.associationPoe(params)
        .then(data => data)
        .catch(error => { throw error; });
    },
    updatePoeReset(params) {
      return api.poe.updatePoeReset(params)
        .then(data => data)
        .catch(error => { throw error; });
    }
  }
});
